import { scrollToBlockById } from '../../../../utils/common-helper';
import { ILoaderService } from '../../loader';
import {
  isLoginLastSource,
  LOGIN_SOURCES,
  getLastLoginSource,
  clearLastLoginSource,
} from '../../user-account-services';
import { UserAccountService } from '../../user-account-services/user-account-service';

export class StoreLoaderService implements ILoaderService {
  _id: string;

  userService?: UserAccountService;

  constructor(userService?: UserAccountService) {
    this.userService = userService;
    this._id = getLastLoginSource();
  }

  // eslint-disable-next-line class-methods-use-this
  checkAttach() {
    return isLoginLastSource(LOGIN_SOURCES.STORE_BUY_BUTTON);
  }

  checkDetach() {
    return (
      isLoginLastSource(LOGIN_SOURCES.STORE_BUY_BUTTON) &&
      !!document.querySelector(`[id='${this._id}'] [data-button-type="buy"]`)
    );
  }

  scrollToButton() {
    scrollToBlockById(this._id, { block: 'center' });
    const interval = setInterval(() => {
      const BB: HTMLElement | null = document.querySelector(
        `[id='${this._id}'] [data-button-type="buy"]`
      );
      if (!BB) {
        return;
      }
      BB.click();
      clearInterval(interval);
    }, 50);
  }

  detach() {
    if (!this.userService?.isAuthorized) {
      return;
    }
    if (this.checkAttach()) {
      clearLastLoginSource();
    }
    this.scrollToButton();
  }
}
